import * as Sentry from '@sentry/nextjs';

export interface ErrorRateLimitData {
    lastErrorTime: number;
    errorCount: number;
    windowMs: number;
}

const errorRateLimiter = new Map<string, ErrorRateLimitData>();

const clearOutdatedEntries = () => {
    const currentTime = Date.now();
    for (const [errorMessage, { lastErrorTime, windowMs }] of errorRateLimiter.entries()) {
        if (currentTime - lastErrorTime > windowMs) {
            errorRateLimiter.delete(errorMessage);
        }
    }
};

export const rateLimitErrors = (
    event: Sentry.Event,
    countThreshold: number,
    windowMs: number,
): Sentry.ErrorEvent | null => {
    if (event.exception && event.exception.values) {
        for (const exception of event.exception.values) {
            const errorMessage = exception.value;
            const currentTime = Date.now();

            if (errorMessage) {
                const errorData = errorRateLimiter.get(errorMessage) || {
                    lastErrorTime: 0,
                    errorCount: 0,
                    windowMs,
                };

                const timeSinceLastError = currentTime - errorData.lastErrorTime;

                if (timeSinceLastError < windowMs) {
                    if (errorData.errorCount >= countThreshold) {
                        return null;
                    } else {
                        errorData.errorCount++;
                        errorRateLimiter.set(errorMessage, errorData);
                    }
                } else {
                    // Reset error count if outside the time window
                    errorData.lastErrorTime = currentTime;
                    errorData.errorCount = 1;
                    errorRateLimiter.set(errorMessage, errorData);
                }
                clearOutdatedEntries();
            }
        }
    }

    return event as Sentry.ErrorEvent;
};
